export enum SearchTypes {
  DMS = -3,
  CCODES = -2,
  IPB_FIGURE = -1,
  MANUAL = 0,
  MODEL = 1
}
